/* MetalWorksMorocco: product descriptions.
   - The sections of a description are shown as a fixed set of accordions, with the same names and in the
     same order on every product (see SECTIONS). An accordion only appears when the description has that
     section. Sections that match none of them go into "More Details" (always last).
   - The intro text before the first section stays visible ("Read more" when it is long).
   - Descriptions without any recognisable section keep the plain "Read more" view.
   The full text always stays in the page HTML (search engines read all of it); only the view changes.
   Read-more styles live in mwm-gallery.css (.mwm-rm); accordion styles are injected below (.mwm-acc). */
(function () {
  var SECTIONS = [
    { title: 'Key Features', match: /^(key features|features|highlights|product highlights|product details|why you.?ll love it|why choose)/i },
    { title: 'Dimensions', match: /^(dimensions?|available sizes|sizes?|measurements|weight)\b/i },
    { title: 'Materials', match: /^(materials?)\b/i },
    { title: 'Valves', match: /^(valves?|cartridges?)\b/i },
    { title: "What's in the Box", match: /^(what.?s in the box|in the box|package includes|the (shower set )?package includes)/i },
    { title: 'Warranty', match: /^(warranty|our warranty|our guarantee|guarantee)/i },
    { title: 'Shipping & Returns', match: /^(shipping|returns?|packaging|carefully packaged|delivery)/i }
  ];
  var MORE_TITLE = 'More Details';
  var CHECKS = /^[\u2714\u2713\u2705\s]+/;
  var CHEVRON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function injectStyles() {
    if (document.getElementById('mwm-acc-styles')) return;
    var s = document.createElement('style');
    s.id = 'mwm-acc-styles';
    s.textContent = [
      '.mwm-acc-intro > h2:first-child,.mwm-acc-intro > h3:first-child{font-size:calc(var(--font-heading-scale) * 2rem);line-height:1.3;margin:0 0 1rem}',
      '.mwm-acc-list{margin-top:1.6rem;border-top:1px solid rgba(var(--color-foreground),.12)}',
      '.mwm-acc{border-bottom:1px solid rgba(var(--color-foreground),.12)}',
      '.mwm-acc > summary{display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:1.4rem 0;cursor:pointer;list-style:none}',
      '.mwm-acc > summary::-webkit-details-marker{display:none}',
      '.mwm-acc__title{font-size:1.5rem;font-weight:600;letter-spacing:.02em;line-height:1.4;color:rgb(var(--color-foreground))}',
      '.mwm-acc > summary svg{flex:0 0 auto;width:1.6rem;height:1.6rem;transition:transform .2s ease}',
      '.mwm-acc[open] > summary svg{transform:rotate(180deg)}',
      '.mwm-acc > summary:focus-visible{outline:2px solid #bea025;outline-offset:2px}',
      '.mwm-acc__body{padding:0 0 1.6rem}',
      '.mwm-acc__body > :first-child,.mwm-acc__hidden + *{margin-top:0}',
      '.mwm-acc__body > :last-child{margin-bottom:0}',
      '.mwm-acc__body li{margin:0 0 .6rem}',
      '.mwm-acc__body li > p{margin:0}',
      '.mwm-acc__sub{margin:1.6rem 0 .4rem;font-family:var(--font-body-family);font-size:1.4rem;font-weight:600;letter-spacing:.02em;line-height:1.4}',
      '.mwm-acc__hidden{position:absolute!important;overflow:hidden;width:1px;height:1px;margin:-1px;padding:0;border:0;clip:rect(0 0 0 0);white-space:nowrap}'
    ].join('');
    document.head.appendChild(s);
  }

  function clean(text) {
    return text.replace(CHECKS, '').replace(/[:\s]+$/, '').trim();
  }

  function categoryOf(label) {
    for (var i = 0; i < SECTIONS.length; i++) if (SECTIONS[i].match.test(label)) return i;
    return -1;
  }

  // Does this node start a section? Real headings (h2-h4), a paragraph that is only a label ("Materials:"),
  // or a paragraph that opens with a known label ("Dimensions: see photos").
  function starterOf(node, firstEl) {
    if (node.nodeType !== 1 || node === firstEl) return null;
    if (/^H[2-4]$/.test(node.tagName)) {
      var label = clean(((node.innerText || node.textContent).split('\n')[0] || ''));
      if (!label || label.length > 80) return null;
      return { kind: 'heading', cat: categoryOf(label), level: +node.tagName.charAt(1), label: label };
    }
    if (node.tagName === 'P') {
      var m = node.textContent.replace(/\s+/g, ' ').trim().match(/^([^:]{2,60}):\s*(.*)$/);
      if (!m) return null;
      var name = clean(m[1]);
      var cat = categoryOf(name);
      if (cat < 0) return null;
      if (!m[2]) return { kind: 'label', cat: cat, level: 6, label: name };
      if (name.length <= 25) return { kind: 'inline', cat: cat, level: 6, label: name };
    }
    return null;
  }

  function hasContent(nodes) {
    return nodes.some(function (n) { return n.nodeType === 1 || n.textContent.trim(); });
  }

  function addReadMore(wrap, inner) {
    var fontSize = parseFloat(getComputedStyle(inner).fontSize) || 16;
    if (inner.scrollHeight <= fontSize * 16) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'mwm-rm__toggle';
    button.setAttribute('aria-controls', inner.id);
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML =
      '<span class="mwm-rm__label">Read more</span>' +
      '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    inner.after(button);
    wrap.classList.add('mwm-rm', 'is-collapsed');
    var label = button.querySelector('.mwm-rm__label');
    button.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      wrap.classList.toggle('is-collapsed', !open);
      button.setAttribute('aria-expanded', String(open));
      label.textContent = open ? 'Read less' : 'Read more';
      if (!open) {
        // After closing, bring the shopper back to the start of the text if it went off screen
        var top = wrap.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 120, behavior: 'smooth' });
      }
    });
  }

  // Returns false (and changes nothing) when the description has no recognisable section.
  function buildAccordions(body) {
    var nodes = Array.from(body.childNodes);
    var firstEl = body.firstElementChild;
    var intro = [];
    var chunks = [];
    var current = null;

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'HR') return;
      var s = starterOf(node, firstEl);
      // An unknown heading under a section (smaller level) is a sub-heading of that section
      if (s && s.kind === 'heading' && s.cat < 0 && current && s.level > current.level) s = null;
      if (!s) { (current ? current.nodes : intro).push(node); return; }

      current = { cat: s.cat, level: s.level, label: s.label, head: null, nodes: [] };
      if (s.kind === 'inline') {
        current.nodes.push(node);
      } else {
        current.head = node;
        var lines = (node.innerText || node.textContent).split('\n').map(function (t) { return t.trim(); }).filter(Boolean);
        if (lines.length > 1) {
          var p = document.createElement('p');
          p.textContent = lines.slice(1).join(' ');
          current.nodes.push(p);
        }
      }
      chunks.push(current);
    });

    // A heading with nothing under it (e.g. a one-line note) is not a section: it stays as plain text in place
    var kept = [];
    chunks.forEach(function (c) {
      if (hasContent(c.nodes)) { kept.push(c); return; }
      if (c.head) (kept.length ? kept[kept.length - 1].nodes : intro).push(c.head);
    });
    chunks = kept;
    if (!chunks.length) return false;

    injectStyles();
    var groups = SECTIONS.map(function (s) { return { title: s.title, chunks: [] }; });
    var more = { title: MORE_TITLE, chunks: [], more: true };
    chunks.forEach(function (c) { (c.cat >= 0 ? groups[c.cat] : more).chunks.push(c); });

    var list = document.createElement('div');
    list.className = 'mwm-acc-list';
    groups.concat([more]).forEach(function (g) {
      if (!g.chunks.length) return;
      var details = document.createElement('details');
      details.className = 'mwm-acc';
      var summary = document.createElement('summary');
      summary.innerHTML = '<span class="mwm-acc__title"></span>' + CHEVRON;
      summary.firstChild.textContent = g.title;
      var inner = document.createElement('div');
      inner.className = 'mwm-acc__body';
      // Original headings stay in the page; they show as sub-titles only when they add information
      var showSubs = g.more || g.chunks.length > 1;
      g.chunks.forEach(function (c) {
        if (c.head) {
          c.head.textContent = c.label;
          c.head.classList.add(showSubs ? 'mwm-acc__sub' : 'mwm-acc__hidden');
          inner.appendChild(c.head);
        }
        c.nodes.forEach(function (n) { inner.appendChild(n); });
      });
      details.appendChild(summary);
      details.appendChild(inner);
      list.appendChild(details);
    });

    while (body.firstChild) body.removeChild(body.firstChild);
    if (hasContent(intro)) {
      var wrap = document.createElement('div');
      wrap.className = 'mwm-acc-introwrap';
      var introBody = document.createElement('div');
      introBody.className = 'mwm-rm__body mwm-acc-intro';
      introBody.id = body.id + '-intro';
      intro.forEach(function (n) { introBody.appendChild(n); });
      wrap.appendChild(introBody);
      body.appendChild(wrap);
      addReadMore(wrap, introBody);
    }
    body.appendChild(list);
    return true;
  }

  function setup(desc, n) {
    if (desc.dataset.mwmRm) return;
    desc.dataset.mwmRm = '1';

    // Wrap the description text, leaving the metafield accordion (if any) outside
    var body = document.createElement('div');
    body.className = 'mwm-rm__body';
    body.id = 'MwmDesc-' + n;
    Array.from(desc.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && node.matches('ul.accordion')) return;
      body.appendChild(node);
    });
    desc.insertBefore(body, desc.firstChild);

    if (buildAccordions(body)) desc.classList.add('mwm-acc-mode');
    else addReadMore(desc, body);
  }

  function init() {
    document.querySelectorAll('.product__description').forEach(function (desc, i) { setup(desc, i); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
